<template>
  <div>
    <base-header type="" class="rsgradient pb-3 pb-1 pt-3 pt-md-5">
    </base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">
        Mi tarjeta
      </b-card-header>
      <b-card-body>

        <div class="reprint" v-if="isReprint">
          <img src="@/assets/rs_card_envelope.png" v-bind:alt="Image" height="40px" style="padding-top: 5px"/>
          <span class="textReprint">Tu nueva tarjeta está en camino</span>
          <b-button class="btn btn-danger" @click="activarTarjeta" style="float: right; margin-right:10px">Activar</b-button>
        </div>

        <div class="row" style="margin-top: 10px">
          <div class="col-md-6">
            <img :src="getImgUrl(Image)" v-bind:alt="Image" style="max-height: 250; max-width: 250px"/>

            <div class="col-md-12" style="margin-top: -65px">
              <div class="font-weight-bold" style="font-size: 10px">
                {{ cardName }}
              </div>
              <div class="font-weight-bold" style="font-size: 10px">
                {{ formattedCardValidity }}
              </div>
              <div class="font-weight-bold" style="font-size: 10px">
                {{ formattedCardNumber }}
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 col-xs-12 col-sm-12" style="margin-top:20px">
            <stats-card
              title="Saldo en mi Tarjeta MasterCard Resimple"
              type="gradient-green"
              v-bind:sub-title="cardCredit"
              icon="ni ni-money-coins"
              class="mb-4 mb-xl-0"
            >
            </stats-card>
          </div>
        </div>
        <div class="row"></div>

        <div class="row"></div>
      </b-card-body>
    </b-card>

    <b-card
      style="margin: 20px; cursor: pointer !important"
      v-on:click="goToRecharge"
    >
      <b-card-body style="padding: 0px !important">
        <div class="row">
          <img src="@/assets/card_reload.png" style="width30px;height:30px;" />
          <span style="vertical-align: middle; margin-left: 10px" class="col"
            >Cargar saldo</span
          >

          <div class="col-2 text-right" style="padding-right: 25px">></div>
        </div>
        <div class="row"></div>
      </b-card-body>
    </b-card>

    <b-card
      style="margin: 20px; cursor: pointer !important"
      v-on:click="goToMovs"
    >
      <b-card-body style="padding: 0px !important">
        <div class="row">
          <img src="@/assets/card_movs.png" style="width30px;height:30px;" />
          <span style="vertical-align: middle; margin-left: 10px" class="col"
            >Ultimos movimientos</span
          >

          <div class="col-2 text-right" style="padding-right: 25px">></div>
        </div>
        <div class="row"></div>
      </b-card-body>
    </b-card>
     <b-card
      style="margin: 20px; cursor: pointer !important"
      v-on:click="goToReverse"
    >
      <b-card-body style="padding: 0px !important">
        <div class="row">
          <img src="@/assets/card_reverse.png" style="width30px;height:30px;" />
          <span style="vertical-align: middle; margin-left: 10px" class="col"
            >Reversar última carga</span
          >

          <div class="col-2 text-right" style="padding-right: 25px">></div>
        </div>
        <div class="row"></div>
      </b-card-body>
    </b-card>
 <b-card
      style="margin: 20px; cursor: pointer !important"
      v-on:click="goToLock"
    >
      <b-card-body style="padding: 0px !important">
        <div class="row">
          <img src="@/assets/card_lock.png" style="width30px;height:30px;" />
          <span style="vertical-align: middle; margin-left: 10px" class="col"
            >Solicitar Bloqueo de Tarjeta</span
          >

          <div class="col-2 text-right" style="padding-right: 25px">></div>
        </div>
        <div class="row"></div>
      </b-card-body>
    </b-card>
    <b-card
      style="margin: 20px; cursor: pointer !important"
      v-on:click="goReprint" v-if="showReprint"
    >
      <b-card-body style="padding: 0px !important" >
        <div class="row">
          <img src="@/assets/card_reprint.png" style="width30px;height:30px;" />
          <span style="vertical-align: middle; margin-left: 10px" class="col"
            >Denuncia por robo o pérdida</span
          >

          <div class="col-2 text-right" style="padding-right: 25px">></div>
        </div>
        <div class="row"></div>
      </b-card-body>
    </b-card>
    <b-card
      style="margin: 20px; cursor: pointer !important"
      v-on:click="goToUnsubscribe"
    >
      <b-card-body style="padding: 0px !important">
        <div class="row">
          <img src="@/assets/card_down.png" style="width30px;height:30px;" />
          <span style="vertical-align: middle; margin-left: 10px" class="col"
            >Solicitar baja</span
          >

          <div class="col-2 text-right" style="padding-right: 25px">></div>
        </div>
        <div class="row"></div>
      </b-card-body>
    </b-card>
     <b-card
      style="margin: 20px; cursor: pointer !important"
      v-on:click="goToCashout" v-if="showCardCashout"
    >
      <b-card-body style="padding: 0px !important">
        <div class="row">
          <img src="@/assets/retirar_dinero.png" style="width30px;height:30px;" />
          <span style="vertical-align: middle; margin-left: 10px" class="col"
            >Retiro de Dinero</span>

          <div class="col-2 text-right" style="padding-right: 25px">></div>
        </div>
        <div class="row"></div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style lang="scss">
    .reprint 
    {
       background-color: #f4f4ba;
       width: auto;
       height: 62px;
       padding-top: 10px;
       padding-left: 20px; 
       padding-bottom: 10px;
    }

    .textReprint
    {
      margin-left: 30px;
      vertical-align: sub;
    }
</style>

<script>
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import generalHelpers from "@/helpers/generalHelpers";

export default {
  components: {},
  props: {
    IsReprint: Boolean,
    StateID: Number
  },
  data() {
    return {
      cardNumber: "",
      cardName: "",
      cardValidityFrom: "",
      cardValidityTo: "",
      cardCredit: "",
      formattedCardValidity: "",
      formattedCardNumber: "",
      Image: "",
      isReprint: this.IsReprint,
      stateID: this.StateID,
      showReprint: true,
      showCardCashout: true
    };
  },
  methods: {
    goToMovs() {
      let context = this;
      context.$router.push("/CardMovements");
    },
    goToRecharge() {
      let context = this;
      context.$router.push("/ChargeCardBalance");
    },
    goToUnsubscribe() {
          let context = this;

      context.$router.push("/RequestUnsubscribe");
    },
    goToLock() {
          let context = this;

      context.$router.push("/RequestLock");
    },
    goToReverse(){
        let context = this;
      context.$router.push("/ReverseLastCharge");
    },
    goReprint(){
        let context = this;
      context.$router.push("/ReprintCard");
    },
    getImgUrl(pet) {
      let context = this;
      var images = require.context('@/assets/', false);
      return images('./' + pet);
    },
    activarTarjeta()
    {
       let context = this;
       context.$router.push({ name: "ApprovedCardTracking", params: { welcomeMessage: "Seguimiento Reimpresón de Tarjeta", isReprint: true, requestState: context.stateID }});
    },
    goToCashout()
    {
        let context = this;
        context.$router.push("/MastercardCashout");
    }
  },
  beforeMount: function () {
    let context = this;

    context.showReprint = context.$store.getters.OPCIONMENUREIMPRESIONTARJETAMASTERCARD;
    context.showCardCashout = context.$store.getters.OPCIONMENURETIRODEDINEROTARJETAMASTERCARD;

    axiosHelpers.axiosPost("Mastercard/CardWalletHome", {}, this, function (
      data
    ) {
      context.cardNumber = data.ResponseVM.CardNumber;
      context.cardName = data.ResponseVM.CardName;
      context.cardValidityFrom = data.ResponseVM.CardValidityFrom;
      context.cardValidityTo = data.ResponseVM.CardValidityTo;
      context.cardCredit = "$" + data.ResponseVM.CardCredit;
      context.formattedCardValidity = data.ResponseVM.FormattedCardValidity;
      context.formattedCardNumber = data.ResponseVM.FormattedCardNumber;
      context.Image = data.ResponseVM.ImagenTarjetaBilletera;
      context.isReprint = data.ResponseVM.IsReprint;
    });
  },
};
</script>